import {
    Skeleton,
    Text
} from '@chakra-ui/react';
import CardField from '@Modules/fraudManagement/components/CardField';
import { createColumnHelper } from '@tanstack/react-table';

export type TFirstChargebackDataTableData = {
  primaryKey: string | number,
  firstChargeback: string,
  count: string,
  total: string,
};

type Props = {
  isLoading: boolean | undefined,
  firstChargebackTitle: string,
};

const columnHelper =
  createColumnHelper<TFirstChargebackDataTableData>();

export function getFirstChargebackDataTableColumns({
  isLoading, firstChargebackTitle
}: Props) {
  
  return [
    columnHelper.accessor('firstChargeback', {
      id: 'firstChargeback',
      header: firstChargebackTitle,
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Text textAlign={'right'}>{props.getValue()}</Text>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('count', {
      id: 'count',
      header: 'Count',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <CardField value={props.getValue()} />
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('total', {
      id: 'total',
      header: 'Total',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {<CardField value={props.getValue()} />}
          </Skeleton>
        );
      },
    }),
  ];
}
